export default __webpack_public_path__ + "static/media/four.47bbe5de.jpeg";